import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getMills } from "../actions/millActions";

import MillCarousel from "./MillCarousel";
import Map from "./Map";
import Navbar from "./Navbar";
import Tour from "./Tour";

import PulseLoader from "react-spinners/PulseLoader";

class Home extends Component {
  componentDidMount() {
    this.props.getMills();
  }

  render() {
    // const isEdge = window.navigator.userAgent.indexOf("Edge") !== -1;
    // const isIE =
    //   window.navigator.userAgent.indexOf("Trident") !== -1 && !isEdge;
    return (
      <div>
        <Navbar />
        {this.props.progress ? (
          <div>
            <div className="spinner" style={{ height: "calc(50vh - 66px)" }}>
              <div style={{ justifyContent: "center", display: "flex" }}>
                <PulseLoader
                  color={"#00568E"}
                  loading={this.props.progress}
                  size={35}
                  margin={5}
                />
              </div>
              <p style={{ marginTop: "20px", textAlign: "center" }}>
                Daten werden vom Server geladen.
              </p>
            </div>
          </div>
        ) : this.props.mills.features ? (
          <div>
            <MillCarousel />
            <Tour />
            <Map />
            {/* ArcGIS API for JS Version 4.17 unterstützt noch Internet Explorer */}
            {/* {!isIE ? <Map /> : (
              <div
                className="noMap"
                style={{
                  border: "1px solid #00568E",
                  padding: "20px",
                  margin: "0px auto",
                  maxWidth: "700px",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div style={{ paddingRight: "20px", paddingTop: "6px" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    fill="#00568E"
                    className="bi bi-map-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16 .5a.5.5 0 0 0-.598-.49L10.5.99 5.598.01a.5.5 0 0 0-.196 0l-5 1A.5.5 0 0 0 0 1.5v14a.5.5 0 0 0 .598.49l4.902-.98 4.902.98a.502.502 0 0 0 .196 0l5-1A.5.5 0 0 0 16 14.5V.5zM5 14.09V1.11l.5-.1.5.1v12.98l-.402-.08a.498.498 0 0 0-.196 0L5 14.09zm5 .8V1.91l.402.08a.5.5 0 0 0 .196 0L11 1.91v12.98l-.5.1-.5-.1z"
                    />
                  </svg>
                </div>
                <div>
                  Die Karte kann nicht in Ihrem Browser angezeigt werden. Für
                  eine korrekte Darstellung können Sie die neuesten Versionen
                  der Browser{" "}
                  <a
                    style={{ color: "#00568E" }}
                    href="https://www.google.com/chrome/"
                    target="_blank"
                    className={"appLink"}
                    rel="noopener noreferrer"
                  >
                    Google Chrome
                  </a>
                  ,{" "}
                  <a
                    style={{ color: "#00568E" }}
                    href="https://www.mozilla.org/de/firefox/new/"
                    target="_blank"
                    className={"appLink"}
                    rel="noopener noreferrer"
                  >
                    Mozilla Firefox
                  </a>
                  ,{" "}
                  <a
                    style={{ color: "#00568E" }}
                    href="https://support.apple.com/downloads/safari"
                    target="_blank"
                    className={"appLink"}
                    rel="noopener noreferrer"
                  >
                    Apple Safari
                  </a>{" "}
                  oder{" "}
                  <a
                    style={{ color: "#00568E" }}
                    href="https://www.microsoft.com/de-de/edge"
                    target="_blank"
                    className={"appLink"}
                    rel="noopener noreferrer"
                  >
                    Microsoft Edge
                  </a>{" "}
              nutzen.
            </div>
              </div>
            )} */}
          </div>
        ) : (
          <div className="spinner" style={{ height: "calc(50vh - 66px)" }}>
            <div
              style={{
                border: "1px solid #00568E",
                padding: "20px",
                margin: "0px 30px",
                maxWidth: "300px",
                justifyContent: "center",
                display: "flex",
                textAlign: "center",
              }}
            >
              Es können zurzeit keine Daten geladen werden. Bitte versuchen Sie
              es zu einem späteren Zeitpunkt noch einmal.
            </div>{" "}
          </div>
        )}
      </div>
    );
  }
}

Home.propTypes = {
  message: PropTypes.object.isRequired,
  progress: PropTypes.bool.isRequired,
  getMills: PropTypes.func.isRequired,
  mills: PropTypes.object.isRequired,
  pdf: PropTypes.bool.isRequired,
  selected: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  progress: state.mill.progress,
  message: state.message,
  mills: state.mill.mills,
  pdf: state.mill.pdf,
  selected: state.mill.selected,
});

export default connect(mapStateToProps, { getMills })(Home);
